import 'twin.macro';
import 'styled-components/macro';

// eslint-disable-next-line no-restricted-imports
import { Portal, Root } from '@radix-ui/react-dialog';

import { useNotificationContext } from '../context/Notifications';
import Notification from '../legacy/components/core/Notification';

export const NotificationsContainer = () => {
  const { notifications, closeNotification } = useNotificationContext();

  return (
    <Root open={notifications.length > 0}>
      <Portal>
        <div tw="fixed right-2 bottom-2 z-toast flex flex-col gap-2 pointer-events-auto">
          {notifications.map(({ id, type, title, duration, message }) => (
            <Notification
              key={id}
              id={id}
              type={type}
              title={title}
              duration={duration}
              message={message}
              onClose={() => closeNotification(id)}
            />
          ))}
        </div>
      </Portal>
    </Root>
  );
};
